import { useEffect } from 'react';
import { useSearchParams } from 'react-router';

export function BentleyLoginExtend() {
    const [searchParams] = useSearchParams();
    const authCode = searchParams.get('code');
    const state = searchParams.get('state');
    const error = searchParams.get('error');

    useEffect(() => {
        // If we have no state, there's no CSRF state to check and we can't validate the response.
        if (state) {
            const bc = new BroadcastChannel(`extend_login.${state}`);

            bc.postMessage({ source: 'bentley-login-extension', code: authCode, state, error });

            // Window is going to close, so we can close the BroadcastChannel.
            bc.close();
        }
        window.close();
    }, []);

    return 'Successfully logged in!';
}
